import { render } from "./TicketDetails.vue?vue&type=template&id=1f7259eb&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"

import "./TicketDetails.vue?vue&type=style&index=0&id=1f7259eb&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\cazino\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7259eb"]])

export default __exports__